import { Icon, IconButton, TextField } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react'
import { ChromePicker } from 'react-color';
import './ColorPicker.css';

export default function ColorPicker({
  disabled = false,
  autoFocus = false,
  label = 'Color',
  value = '',
  onChange = () => { },
  onBlur = () => { },
  name = `${Math.round(Math.random() * 100)}`,
}) {
  const [PickerHidden, setPickerHidden] = useState(true);
  const PickerHiddenRef = React.useRef(PickerHidden);
  const TextFieldRef = useRef(null);
  // const [Color, setColor] = useState(value.length > 0 ? value : '#000');

  const _setPickerHidden = data => {
    PickerHiddenRef.current = data;
    setPickerHidden(data);
  };

  // useEffect(() => {
  //   console.log(value);
  //   setColor(value);
  // }, [value])

  useEffect(() => {
    window.addEventListener('click', _onDocumentClick);

    return () => {
      window.removeEventListener('click', _onDocumentClick);
    }
    
    // eslint-disable-next-line
  }, []);

  const _onDocumentClick = (event) => {
    // console.log(PickerHidden,)
    if (PickerHiddenRef.current) return;
    // console.log(event.path);
    // event.path.forEach((ele) => {
    //   console.log(ele.className)
    // })
    let clickPicker = event.path.find((ele) => ele.className && ele.className.search('picker') >= 0)
    if (!clickPicker) _setPickerHidden(true);
  }

  const _onButtonClick = () => {
    _setPickerHidden(false);
  }

  const _onColorChange = (color) => {
    // setColor(color.hex)
    onChange(color.hex.replace(/#/g, ''));
    onBlur()
  }

  return (
    <div id={`color-picker-${name}`}>
      <div className='color-picker-container' style={{ display: 'flex', justifyContent: 'space-between' }}>
        <TextField
          ref={TextFieldRef}
          disabled={true}
          autoFocus={autoFocus}
          variant="outlined"
          className="form-field"
          type='text'
          label={`${label}`}
          value={value || ''}
        // onChange={(e) => { this.onChange(formField, e, form) }}
        // onBlur={(e) => { this.onBlur(formField, e) }}
        />
        <IconButton style={{ color: `#${value.length > 0 ? value : '000'}` }} onClick={_onButtonClick}>
          <Icon>build</Icon>
        </IconButton>
        {!PickerHidden && (
          <ChromePicker
            color={value}
            onChangeComplete={_onColorChange}
          />
        )}
      </div>
    </div>
  )
}
